// extracted by mini-css-extract-plugin
module.exports = {"custom-styled-label":"CustomStyles_custom-styled-label__RISTl"};